// Central site metadata used across marketing pages and SEO.
// Update these values in one place to re-brand or change contact details.

export const SITE = {
  name: "VerifyDeceased",
  legalName: "VerifyDeceased by LeadCruncher",
  parent: "LeadCruncher",
  parentUrl: "https://leadcruncher.com",
  domain: "https://verifydeceased.com",
  twitterHandle: "@Leadcruncher",
  tagline: "Verify deceased consumers. Stop identity fraud.",
  mission: "Verify death. Prevent fraud. Protect families.",
  description:
    "VerifyDeceased helps banks, lenders and enterprises confirm whether a consumer is deceased. Match your records against fresh nationwide death data with name, date of birth, date of death, age and last known property address.",
  // Trimmed to stay under the ~160 character limit search engines display.
  metaDescription:
    "Confirm whether a consumer is deceased using nationwide death data refreshed weekly. Get date of death, age and last known address for banks and fraud teams.",
  email: "sales@verifydeceased.com",
  supportEmail: "support@verifydeceased.com",
  phone: "+1 (909) 315-5330",
  phoneHref: "tel:+19093155330",
  address: "8023 Jennet Street, Alta Loma, CA 91701",
  addressParts: {
    street: "8023 Jennet Street",
    city: "Alta Loma",
    region: "CA",
    postalCode: "91701",
    country: "US"
  },
  foundingYear: "2024",
  // The platform launched in 2024, but the obituary research program behind it started in 2012.
  researchSince: "2012",
  social: {
    linkedin: "https://www.linkedin.com/company/leadcruncher",
    x: "https://x.com/Leadcruncher",
    facebook: "https://www.facebook.com/profile.php?id=61578444806358"
  }
};

export const PRICING = {
  standardPerRecord: 0.04,
  bulkPerRecord: 0.01,
  bulkThreshold: 100000
};

export const STATS = {
  weeklyRecords: "90,000+",
  dataFreshnessDays: 7,
  statesCovered: 50,
  obituariesResearched: "30 million+",
  // The window after a passing where no public confirmation usually exists yet.
  highRiskWindowDays: 90
};
